import { render, staticRenderFns } from "./bottomInfo.vue?vue&type=template&id=02e5ed4c&"
import script from "./bottomInfo.vue?vue&type=script&lang=js&"
export * from "./bottomInfo.vue?vue&type=script&lang=js&"
import style0 from "./bottomInfo.vue?vue&type=style&index=0&id=02e5ed4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports